/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipList
 */
export interface ShipList {
    /**
     * The groups that the shiplist is shared with
     * @type {Array<string>}
     * @memberof ShipList
     */
    acl?: Array<string>;
    /**
     * The id of the shiplist
     * @type {string}
     * @memberof ShipList
     */
    id?: string;
    /**
     * The color that the shiplist ships get
     * @type {string}
     * @memberof ShipList
     */
    color?: string;
    /**
     * The name of the shiplist. Notice this name must be unique for the owner and all users affected by the ACL
     * @type {string}
     * @memberof ShipList
     */
    name?: string;
    /**
     * Max number of ships in the shiplist for user modifiable lists.
     * @type {number}
     * @memberof ShipList
     */
    max?: number;
    /**
     * Who own the shape
     * @type {string}
     * @memberof ShipList
     */
    owner?: string;
}

/**
 * Check if a given object implements the ShipList interface.
 */
export function instanceOfShipList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipListFromJSON(json: any): ShipList {
    return ShipListFromJSONTyped(json, false);
}

export function ShipListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
    };
}

export function ShipListToJSON(value?: ShipList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acl': value.acl,
        'id': value.id,
        'color': value.color,
        'name': value.name,
        'max': value.max,
        'owner': value.owner,
    };
}

